import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { DemographicsState, DemographicsData } from '../../components/demographics/types';

const initialState: DemographicsState = {
  data: null,
  segments: [],
  industries: [],
  loading: false,
  error: null,
};

const demographicsSlice = createSlice({
  name: 'demographics',
  initialState,
  reducers: {
    fetchDemographicsRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchDemographicsSuccess: (state, action: PayloadAction<DemographicsData>) => {
      state.loading = false;
      state.data = action.payload;
      
      // Parse JSON strings
      try {
        state.segments = JSON.parse(action.payload.key_demographic_segments);
      } catch (e) {
        state.segments = [];
      }
      
      try {
        state.industries = JSON.parse(action.payload.major_employers_institutions);
      } catch (e) {
        state.industries = [];
      }
    },
    fetchDemographicsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearDemographics: (state) => {
      state.data = null;
      state.segments = [];
      state.industries = [];
      state.error = null;
    },
  },
});

export const {
  fetchDemographicsRequest,
  fetchDemographicsSuccess,
  fetchDemographicsFailure,
  clearDemographics,
} = demographicsSlice.actions;

export default demographicsSlice.reducer;
